import React from "react";
import { ElementProps } from "./ContentElement";
import { Tweet } from "react-tweet";
import { ContentElementOgp } from "./ContentElementOgp";

/* URLを貼り付けた時に、oEmbed等で変換して表示されるもの */

export function ContentElementEmbedLink(props: ElementProps) {
  const element = props.element;
  if (!element.src) {
    return null;
  }
  switch (element.service) {
    case "comici":
      return (
        <div className="g-desc-iframe-wrap">
          <iframe src={element.src} width="640" height="360"></iframe>
        </div>
      );
    case "youtube":
      return (
        <div className="g-desc-iframe-wrap">
          <iframe src={element.src} width="640" height="360"></iframe>
        </div>
      );
    case "linkdata":
      return <ContentElementOgp element={element} />;
    case "twitter": {
      const match =
        element.src &&
        element.src
          .toString()
          .match(/^https?:\/\/(twitter|x)\.com\/(?:#!\/)?(\w+)\/status(?:es)?\/(\d+)(?:\/.*)?$/);
      if (match) {
        const tweetId = match[3];
        return (
          <div className="g-desc-tweet">
            <Tweet id={tweetId} />
          </div>
        );
      } else {
        return <span>Tweet ID extract error</span>;
      }
    }
    default:
      return <span>{element.service} is not supported</span>;
  }
}
